import { createSelector } from 'reselect';
import { RootState } from '../reducers';

const selectAppState = (state: RootState) => state.app;

export const selectDataSources = createSelector([selectAppState], app => app.dataSources || []);

export const selectGridPageStatus = createSelector([selectAppState], app => app.gridPageStatus);

export const selectSelectedAsset = createSelector([selectAppState], app => app.selectedAsset);

export const selectTokenUpdateCounter = createSelector([selectAppState], app => app.tokenUpdateCounter);

export const selectGraphMap = createSelector([selectAppState], app => app.graphMap);

export const selectDatadogToken = createSelector([selectAppState], app => app.datadogToken);

export const selectRootHighlighted = createSelector([selectAppState], app => app.rootHighlighted);

export const selectOpenedNodeId = createSelector([selectAppState], app => app.openedNodeId);

export const selectClosedNodeId = createSelector([selectAppState], app => app.closedNodeId);

export const makeSelectDataSourceByName = (name: string) =>
  createSelector([selectDataSources], dataSources => dataSources.find(ds => ds.name === name));
